//NOTE autogenerated by export script
export {AdminFailedNotificationsService as AdminFailedNotifications} from './adminFailedNotifications.service'
export {AdminOrderItemConfigurationsService as AdminOrderItemConfigurations} from './adminOrderItemConfigurations.service'
export {AdminOrdersService as AdminOrders} from './adminOrders.service'
export {BffAdminOofWebService as BffAdminOofWeb} from './bffAdminOofWeb.service'
export {BffOofWebService as BffOofWeb} from './bffOofWeb.service'
export {ConfigTemplatesAdminAPIService as ConfigTemplatesAdmin} from './configTemplatesAdminAPI.service'
export {ConfigTemplatesCustomerAPIService as ConfigTemplatesCustomer} from './configTemplatesCustomerAPI.service'
export {MeUserService as MeUser} from './meUser.service'
export {OrderDeviceAllocationAdminAPIService as OrderDeviceAllocationAdmin} from './orderDeviceAllocationAdminAPI.service'
export {OrderItemConfigurationsService as OrderItemConfigurations} from './orderItemConfigurations.service'
export {OrderItemDevicesService as OrderItemDevices} from './orderItemDevices.service'
export {OrderItemsService as OrderItems} from './orderItems.service'
export {OrdersService as Orders} from './orders.service'
export {RmaAdminService as RmaAdmin} from './rmaAdmin.service'
export {RmaCustomerService as RmaCustomer} from './rmaCustomer.service'
export {SystemControllerService as System} from './systemController.service'
export {UsersService as Users} from './users.service'
export {BASE_PATH} from '../variables'
export {ApiModule} from '../api.module'
export {AllServices as All} from './allService'